<script>
export default {
    props: {
        defaultBackgroundVerificationSpecs: {
            type: Array,
            required: true
        },
        iFactsChecks: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        },
    },

    data() {
        return {
            backgroundVerificationSpecs: [...this.defaultBackgroundVerificationSpecs]
        }
    },

    methods: {
        addBackgroundVerificationSpec() {
            this.backgroundVerificationSpecs.push({
                id: null,
                title: '',
                method: '',
                notes: ''
            })
        },
        removeBackgroundVerificationSpec(index) {
            this.backgroundVerificationSpecs.splice(index, 1)
        }
    }
}
</script>

<template>
    <div class="grid-x grid-padding-x">
        <div class="cell medium-8 large-12">
            <div v-if="backgroundVerificationSpecs.length > 0" class="grid-x grid-padding-x mb-2">
                <div class="cell pl-10 ml-10 small-5 large-4">
                    <label>Verification Type:</label>
                </div>

                <div class="cell pl-4 ml-1 small-3 large-3">
                    <label>Method:</label>
                </div>

                <div class="cell pl-4 ml-1 small-3 large-3">
                    <label>Notes:</label>
                </div>
            </div>

            <div v-for="(backgroundVerificationSpec, i) in backgroundVerificationSpecs" class="grid-x grid-padding-x mb-2">
                <input v-if="backgroundVerificationSpec.id" :disabled="disabled" :name="`background_verification_specs[${i}][id]`" type="hidden" required v-model="backgroundVerificationSpec.id" />

                <div class="cell pl-10 ml-10 pr-0 small-5 large-4">
                    <input :disabled="disabled" :name="`background_verification_specs[${i}][title]`" type="text" required v-model="backgroundVerificationSpec.title" />
                </div>

                <div class="cell pl-4 ml-1 pr-0 small-3 large-3">
                    <select :disabled="disabled" :name="`background_verification_specs[${i}][method]`" required v-model="backgroundVerificationSpec.method">
                        <option value="ifacts">iFacts</option>
                        <option value="manual">Manual</option>
                    </select>
                </div>

                <div class="cell pl-4 ml-1 pr-0 small-3 large-3">
                    <template v-if="backgroundVerificationSpec.method === 'ifacts'">
                        <select :disabled="disabled" :name="`background_verification_specs[${i}][ifacts_check_id]`" required v-model="backgroundVerificationSpec.ifacts_check_id">
                            <option disabled>---iFacts Check ID---</option>
                            <option v-for="check in iFactsChecks" :value="check.id">
                                {{ check.title }}

                                <template v-if="check.type">
                                    - {{ check.type }}
                                </template>
                            </option>
                        </select>

                        <input :name="`background_verification_specs[${i}][notes]`" value="" type="hidden" />
                    </template>
                    <template v-else>
                        <textarea :disabled="disabled" :name="`background_verification_specs[${i}][notes]`" rows="3" required v-model="backgroundVerificationSpec.notes"></textarea>

                        <input :name="`background_verification_specs[${i}][ifacts_check_id]`" value="" type="hidden" />
                    </template>
                </div>

                <div class="cell small-1 large-1">
                    <div v-if="!disabled" @click="() => removeBackgroundVerificationSpec(i)" class="remove-button"><i class="fas fa-minus-circle"></i></div>
                </div>
            </div>

            <div v-if="!disabled" @click="addBackgroundVerificationSpec" class="add-button"><i class="fas fa-plus-circle"></i></div>

            <input v-if="backgroundVerificationSpecs.length === 0" name="background_verification_specs" value="" type="hidden" />
        </div>
    </div>
</template>